import { createFileRoute, Link, Outlet } from '@tanstack/react-router'

// Settings layout: one nav across Profile / Notifications / Sessions / Invites.
export const Route = createFileRoute('/_app/settings')({
  component: () => {
    const { me } = Route.useRouteContext()
    const tabs = [
      { to: '/settings/profile', label: 'Profile' },
      { to: '/settings/notifications', label: 'Notifications' },
      { to: '/settings/sessions', label: 'Sessions' },
      ...(me.role === 'admin' ? [{ to: '/settings/invites', label: 'Invites' }, { to: '/settings/users', label: 'Users' }, { to: '/settings/workspace', label: 'Workspace' }, { to: '/settings/emoji', label: 'Emoji' }, { to: '/settings/audit', label: 'Audit log' }] : []),
    ] as const
    return (
      <div className="flex h-full min-h-0 flex-col">
        <header className="flex h-11 items-center gap-1 border-b border-border px-3" data-testid="settings-nav">
          <span className="mr-3 text-[13px] font-semibold">Settings</span>
          {tabs.map((t) => (
            <Link key={t.to} to={t.to} className="rounded-md px-2 py-1 text-[13px] text-fg-muted hover:bg-bg-hover hover:text-fg" activeProps={{ className: 'bg-bg-hover text-fg font-medium' }}>
              {t.label}
            </Link>
          ))}
        </header>
        <div className="min-h-0 flex-1 overflow-y-auto">
          <Outlet />
        </div>
      </div>
    )
  },
})
